import {
  approvalPoliciesQuery,
  approvalPolicyReferenceQuery,
} from "@common/api"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { ApprovalPoliciesForm } from "./-components/approval-policies/form"
import { JsonReference } from "./-components/json-document/reference"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/approval-policies",
)({
  staticData: { breadcrumb: "Approval Policies" },
  loader: ({ context: { queryClient }, params }) =>
    Promise.all([
      queryClient.ensureQueryData(
        approvalPoliciesQuery({ tenant_id: params.tenantId }),
      ),
      queryClient.ensureQueryData(
        approvalPolicyReferenceQuery({ tenant_id: params.tenantId }),
      ),
    ]),
  component: ApprovalPoliciesTab,
})

function ApprovalPoliciesTab(): React.ReactElement {
  const { tenantId } = Route.useParams()
  const showToast = useCustomToast()
  const { data: policies } = useSuspenseQuery(
    approvalPoliciesQuery({ tenant_id: tenantId }),
  )
  const { data: reference } = useSuspenseQuery(
    approvalPolicyReferenceQuery({ tenant_id: tenantId }),
  )

  return (
    <div className="space-y-6">
      <ApprovalPoliciesForm
        tenantId={tenantId}
        policies={policies}
        onSave={() => showToast("Saved", "Approval policies saved", "success")}
      />
      <JsonReference
        title="Reference: record types, minimums, people and the policy schema"
        reference={reference}
      />
    </div>
  )
}
